var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoodWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 0h10M0 1h1m10 0h1M0 2h1m10 0h1M0 3h1m10 0h1M0 4h1m10 0h1M0 5h1m10 0h1M0 6h1m10 0h1M0 7h1m10 0h1M0 8h1m10 0h1M0 9h1m10 0h1M0 10h1m10 0h1M1 11h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7f3300",
    d: "M1 1h9M2 2h7M3 3h5M4 4h3M5 5h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#491b10",
    d: "M10 1h1M9 2h2M8 3h3M7 4h4M6 5h5M7 6h4M8 7h3M9 8h2m-1 1h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9b5200",
    d: "M1 2h1M1 3h2M1 4h3M1 5h4M1 6h5M1 7h4M1 8h3M1 9h2m-2 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#662800",
    d: "M6 6h1M5 7h3M4 8h5M3 9h7m-8 1h9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodWall);
export default __webpack_public_path__ + "static/media/wood-wall.dcc6abba77a31ca12b4402629fd7c6c3.svg";
export { ForwardRef as ReactComponent };